import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const offerLabel = (end, now) => {
  const ms = end - now;
  if (ms <= 0) return null;
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  if (d >= 1) return `Ends ${DAYS[end.getDay()]} · ${d}d ${h}h`;
  return `Ends in ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const OfferCountdown = ({ endsAt, testId }) => {
  const end = endsAt ? new Date(endsAt) : null;
  const valid = end && !Number.isNaN(end.getTime());
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (!valid) return undefined;
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, [valid]);
  const text = valid ? offerLabel(end, now) : null;
  if (!text) return null;
  return (
    <span data-testid={testId} className="mt-1 inline-flex items-center gap-1 rounded-md bg-coral-soft px-1.5 py-0.5 text-[10px] font-extrabold text-coral-dark tabular-nums">
      <Timer className="h-3 w-3" />{text}
    </span>
  );
};
